import { defineComponent as _defineComponent } from 'vue'
import TargetsMetricSelect from '../inputs/TargetsMetricSelect.vue';
import { useI18n } from '@/composables/i18n';
import { ConsoleEnum } from '@/models/enums/ConsoleEnum';
import { TargetsMetric } from '@/models/enums/TargetsMetric';
import { Customer } from '@/models/tenant';
import { CreateUserTarget, UserTarget } from '@/models/userTarget';
import { userTargetsService } from '@/services/userTargets.service';
import { isNil } from '@/utils/misc';
import {
  minValue,
  numeric,
  required,
  requiredIf,
  sameAs,
  withLocalizedValidators,
} from '@/utils/validation';
import useVuelidate from '@vuelidate/core';
import { helpers, not } from '@vuelidate/validators';
import { computed, reactive, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TargetFormModal',
  props: {
    console: null,
    customer: null,
    userTarget: null
  },
  emits: ['save', 'close'],
  setup(__props: any, { emit }) {

const props = __props as {
  console: ConsoleEnum;
  customer: Customer;
  userTarget?: UserTarget;
};





const { t } = useI18n();

const editedUserTarget = reactive<CreateUserTarget>({
  tenantId: props.customer.id,
  targetMetric: props.userTarget?.targetMetric ?? TargetsMetric.None,
  target1: props.userTarget?.target1 ?? null,
  target2: props.userTarget?.target2 ?? null,
});
const isSubmitting = ref(false);

const MAX_VALUE_OEE = 100;

const validations = {
  targetMetric: withLocalizedValidators('inputs.targets_chart_select.label', {
    required,
    notNone: helpers.withMessage(
      () => t('form.select_validation').toString(),
      not(sameAs(TargetsMetric.None)),
    ),
  }),
  target1: withLocalizedValidators('target.target_value.label', {
    required,
    numeric,
    minValue: minValue(0),
    maxValue: helpers.withMessage(
      (props) =>
        t('validation.maxValue', {
          fieldName: props.$params.fieldName,
          maxValue: MAX_VALUE_OEE,
        }).toString(),
      (value: number) =>
        ![TargetsMetric.LaserOee, TargetsMetric.TubeOee].includes(
          editedUserTarget.targetMetric,
        ) || value <= MAX_VALUE_OEE,
    ),
  }),
  target2: withLocalizedValidators('target.target_value.label', {
    required: requiredIf(() => hasMultipleTargetValues.value),
    numeric,
    minValue: minValue(0),
  }),
};
const v$ = useVuelidate(validations, editedUserTarget);

async function onSubmit() {
  isSubmitting.value = true;
  try {
    if (isEdit.value) {
      await userTargetsService.update(props.userTarget!.id!, editedUserTarget);
    } else {
      await userTargetsService.create(editedUserTarget);
    }
    emit('save');
    emit('close');
  } finally {
    isSubmitting.value = false;
  }
}

function getErrorMessage(
  key: keyof typeof editedUserTarget,
): string | undefined {
  return v$.value[key].$errors?.[0]?.$message;
}

const numberOfTargetValues = computed((): number =>
  userTargetsService.store.getMetricNumberOfTargetValues(
    editedUserTarget.targetMetric,
  ),
);

const hasMultipleTargetValues = computed(() => numberOfTargetValues.value > 1);

const isEdit = computed(() => !isNil(props.userTarget));

const modalTitle = computed(() => {
  if (isEdit.value) {
    return t('action.edit').toString();
  } else {
    return t('action.create').toString();
  }
});

const actionTitle = computed(() => {
  if (isEdit.value) {
    return t('action.save').toString();
  } else {
    return t('action.create').toString();
  }
});

return { __sfc: true,props, emit, t, editedUserTarget, isSubmitting, MAX_VALUE_OEE, validations, v$, onSubmit, getErrorMessage, numberOfTargetValues, hasMultipleTargetValues, isEdit, modalTitle, actionTitle, TargetsMetricSelect }
}

})